import React, { useState } from "react";
import Header from "../components/Header";
import AdminSidePanel from "../components/AdminSidePanel";
import FetRepTable from "../components/FetRepTable";
import "./Admin.css";

const AdminPage = () => {
  const [sidePanelOpen, setSidePanelOpen] = useState(false);
  const [sortMethod, setSortMethod] = useState("");

  return (
    <div>
      <Header />

      <div style={{ padding: '20px 20px 0' }}>
        <button
          onClick={() => setSidePanelOpen(true)}
          style={{
            padding: '8px 12px',
            fontSize: '16px',
            backgroundColor: '#F4A261',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer',
            color: '#5E503F'
          }}
        >
          ☰ Menu
        </button>
      </div>

      {sidePanelOpen && (
        <div className="overlay" onClick={() => setSidePanelOpen(false)} />
      )}

      <div className={`sidePanel ${sidePanelOpen ? 'open' : ''}`}>
        <button
          onClick={() => setSidePanelOpen(false)}
          style={{
            marginLeft: '12px',
            marginBottom: '20px',
            fontSize: '18px',
            background: 'none',
            border: 'none',
            color: '#5E503F',
            cursor: 'pointer'
          }}
        >
          ✖ Close
        </button>
        <AdminSidePanel />
      </div>

      <div style={{ padding: '40px 20px 100px' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '70px' }}>
          <h2 style={{ color: '#5E503F', fontWeight: "bold" }}>Recipes to Feature</h2>
          <select value={sortMethod} onChange={e => setSortMethod(e.target.value)}>
            <option value="" disabled hidden>Sort By</option>
            <option>Likes</option>
            <option>Dates</option>
          </select>
        </div>

        <div style={{ marginTop: '30px' }}>
          <FetRepTable sortBy={sortMethod}/>
        </div>
      </div>
    </div>
  );
};

export default AdminPage;